import React, { Component } from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import { getRoutes, protectedRoutes, routes } from "../../routes";
import "./Base.css";
import Header from "../../components/header/Header";
import LeftMenu from "../../components/leftmenu/LeftMenu";

// Redux
import withShipment from "../../withShipment";
import {userInfoSelector, isAuthenticatedSelector} from "../../redux/selectors/auth";
import {authLogout, refreshUserInfo} from "../../redux/actions/auth";
import { ROUTE_TYPE } from "../../routes/constants";
import Login from "../Login/Login";
import { showingMenuItemsSelector } from "../../redux/selectors/global";
import PropTypes from "prop-types";
import Slide from "@material-ui/core/Slide";
import PageNotFound from "../../routes/PageNotFound";

// Render the 403 variant for routes the user is authenticated for but
// has not been granted access to. Defined here so it carries an
// explicit `code` prop into the shared error component.
const ForbiddenPage = (props) => <PageNotFound {...props} code={403} />;

class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.matchMedia('(max-width: 800px)').matches,
    };
    this.mobileMq = window.matchMedia('(max-width: 800px)');
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
    }
  }

  componentDidMount() {
    // React to viewport changes so the desktop left menu / mobile drawer
    // split flips correctly on rotate/resize without needing a refresh.
    this.handleViewportChange = (e) => this.setState({ isMobile: e.matches });
    if (this.mobileMq.addEventListener) {
      this.mobileMq.addEventListener('change', this.handleViewportChange);
    } else if (this.mobileMq.addListener) {
      this.mobileMq.addListener(this.handleViewportChange);
    }

    // Re-pull the current user's authorities/routes whenever the tab
    // regains focus, so permission edits made elsewhere (or by another
    // admin) take effect without a logout/login cycle.
    this.handleFocus = () => {
      if (!this.props.isAuthenticated) return;
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      this.props.refreshUserInfo();
    };
    window.addEventListener('focus', this.handleFocus);
    document.addEventListener('visibilitychange', this.handleFocus);

    if (this.props.isAuthenticated) {
      this.props.refreshUserInfo();
    }
  }

  componentWillUnmount() {
    if (this.mobileMq && this.handleViewportChange) {
      if (this.mobileMq.removeEventListener) {
        this.mobileMq.removeEventListener('change', this.handleViewportChange);
      } else if (this.mobileMq.removeListener) {
        this.mobileMq.removeListener(this.handleViewportChange);
      }
    }
    if (this.handleFocus) {
      window.removeEventListener('focus', this.handleFocus);
      document.removeEventListener('visibilitychange', this.handleFocus);
    }
  }


  protectRoutes = () => {
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : []
    return getRoutes().filter(route => userRoutes.includes(route.id)).concat(routes)
  }

  // Routes that exist in the system but the current user lacks access
  // to. These render the 403 page so the user gets a clear "restricted"
  // signal instead of falling through to 404.
  forbiddenRoutes = () => {
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : []
    return getRoutes().filter(route => route.id && !userRoutes.includes(route.id))
  }

  // Resolve the path the user should land on at '/'. Honors a per-user
  // defaultRoute (set in Manage Employee) and falls back to Business
  // Tracker when the user lacks access to that route id, then to the
  // first accessible menu item.
  resolveLandingPath = () => {
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : [];
    const allRoutes = getRoutes();
    const accessible = allRoutes.filter(r => r.id && userRoutes.includes(r.id));

    const preferredId = this.props.userInfo.defaultRoute;
    if (preferredId) {
      const match = accessible.find(r => r.id === preferredId);
      if (match) return match.path;
    }

    const businessTracker = accessible.find(r => r.id === 'business-tracker');
    if (businessTracker) return businessTracker.path;

    return accessible[0]?.path || '/business-tracker';
  };

  leftMenuRoutes = () => {
    let displayedRoutes = [];
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : [];
    let dividerCount = 0;

    // The user-pinned default view jumps to the top of the sidebar.
    // We only promote top-level entries (MENU_ITEM / SUB_MENU); a
    // pinned sub-menu item stays nested under its parent.
    const defaultRouteId = this.props.userInfo.defaultRoute;
    const promoted = defaultRouteId
      ? protectedRoutes.find(r =>
          r.type !== ROUTE_TYPE.DIVIDER
          && r.id === defaultRouteId
          && userRoutes.includes(r.id))
      : null;

    if (promoted) {
      displayedRoutes.push(promoted);
      displayedRoutes.push({ type: ROUTE_TYPE.DIVIDER, sidebar: true });
      dividerCount = 1;
    }

    protectedRoutes.forEach(route => {
      if (route === promoted) return;

      if (route.type === ROUTE_TYPE.DIVIDER) {
        if (dividerCount === 0) {
          displayedRoutes = [...displayedRoutes, route];
          dividerCount++;
        }
      } else if (userRoutes.includes(route.id)) {
        displayedRoutes = [...displayedRoutes, route];
        dividerCount = 0;
      }
    });

    return displayedRoutes;
  };

  render() {
    return (
      <>
        <div className="custom-container-fluid">
          <div style={{ width: '100%' }}>
            {this.props.isAuthenticated && (
              <Header
                logout={this.props.authLogout}
                firstname={this.props.userInfo.firstname}
                userRoutes={[...this.props.userInfo.routes]}
                routes={this.leftMenuRoutes()}
              />
            )}


            <div className="custom-container-fluid">
              <div
                className="leftContainer"
                style={{ backgroundColor: '#000c36', color: 'white' }}
              >
                {this.props.isAuthenticated && !this.state.isMobile && (
                  <Slide
                    direction="right"
                    in={this.props.showingMenuItems}
                    mountOnEnter
                    unmountOnExit
                  >
                    <LeftMenu
                      logout={this.props.authLogout}
                      routes={this.leftMenuRoutes()}
                      userRoutes={[...this.props.userInfo.routes]}
                      isDrawer={false}
                    />
                  </Slide>
                )}
              </div>

              <div
                className={
                  this.props.showingMenuItems && !this.state.isMobile && this.props.isAuthenticated
                    ? 'rightContainer'
                    : 'fullWidthContainer'
                }
              >
                <Switch>
                  {this.protectRoutes().map((route) => (
                    <Route
                      key={route.id}
                      component={route.component}
                      path={route.path}
                    />
                  ))}

                  <Route
                    key='base'
                    path='/'
                    exact
                    render={() => (this.props.isAuthenticated
                      ? <Redirect to={this.resolveLandingPath()} />
                      : <Login />)}
                  />

                  {/* Defined paths the user lacks access to → 403 page. */}
                  {this.props.isAuthenticated && this.forbiddenRoutes().map((route) => (
                    <Route
                      key={`forbidden-${route.id}`}
                      component={ForbiddenPage}
                      path={route.path}
                    />
                  ))}

                  {/* Catch-all → 404 page. Must be last. */}
                  <Route component={PageNotFound} />
                </Switch>
              </div>
            </div>
          </div>

        </div>

        {/*<Footer />*/}

      </>
    );
  }
}

Base.propTypes = {
  userInfo: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  showingMenuItems: PropTypes.bool,
};

Base.defaultProps = {
  userInfo: {},
  isAuthenticated: false,
  showingMenuItems: false,
};

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  isAuthenticated: isAuthenticatedSelector(state),
  showingMenuItems: showingMenuItemsSelector(state),
});

const actionCreators = {
  authLogout,
  refreshUserInfo,
};

export default withShipment(
    {
      mapStateToProps,
      actionCreators,
    },
    Base
);
